// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1FCxi","footer":"ModalCreateQualiphyProcedure_footer__1qWuR","additionData":"ModalCreateQualiphyProcedure_additionData__1xfg6"};